import React, { FunctionComponent } from 'react';
import { components, MenuListProps } from 'react-select';
import { SelectOptionData } from '@/components/SelectFloatingLabel/SelectFloatingLabel';

const MenuList: FunctionComponent<MenuListProps<SelectOptionData>> = (props) => {
  return (
    <components.MenuList
      {...props}
      data-testid="select-menu"
      className="z-50 w-full bg-white p-3 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
      {props.children}
    </components.MenuList>
  );
};

export default MenuList;
